import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  changeAuditorId ({ target }: { target: HTMLInputElement }): void {
    const auditorId = target.value
    this.dispatch('changeAuditor', { detail: { auditorId } })
  }
}
